export default "__VITE_ASSET__DgAkqT4y__"